<template lang='pug'>
.introduce-container(v-if="!bookMarksLoading")
    .list-container
        imgBox.list(v-for="(item,index) in data" :key="index" :topTitle="index" :img="item.img" :id='item.id' type="shoucang")
</template>

<script>
import { mapState } from 'vuex'
import imgBox from './components/imgbox'
import { getDataHierarchies } from '@custouch/proxy-use'
import { getCmsStr } from './levelTitle'
export default {
    name:'introduce',
    components:{
        imgBox
    },
    data() {
        return {
            data:{}
        }
    },
    methods:{
        
    },
    computed:{
        ...mapState(['bookMarks','memberInfo','bookMarksLoading'])
    },
    async created() {
        const cms = getCmsStr({mId: this.$route.meta.mId})
        this.$root.$emit('pageview',{cms})
        this.$root.$emit('action',{name:this.$route.name})
        const { module } = window.env.VITE_DATA
        const data = await getDataHierarchies(module.product)
        this.data = data.reduce((pre,cur)=>{
            if(!pre[cur.detail.title]){
                pre[cur.detail.title] = {
                    img:cur.detail.img,
                    id:cur.id
                }
            }
            return pre
        },{})
    }
}
</script>

<style scoped lang='less'>
.introduce-container{
    padding:0rem  1rem 0 1rem;
    .list-container{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .list{
            margin-bottom:1.2rem;
        }
    }
   
}

</style>